<template>
  <v-app id="inspire" style="background: #f8f9fa">
    <div class="ma-0 pr-6 pl-6">
      <titleAgency/>
      <v-tabs
        v-model="tab"
        color="#2BA197"
        style="margin-top: 0px;"
        background-color="titlebackground"
      >
        <v-tabs-slider class="ml-0" color="#2BA197"></v-tabs-slider>

        <v-tab
          v-for="item in items"
          :key="item"
          style="font-weight: 700;font-size: 16px;letter-spacing: 1px;"
        >
          <span class="ml-2">{{ item }}</span>
        </v-tab>

        <v-tabs-items v-model="tab" style="border-radius: 16px;">
          <v-tab-item>
            <div class="my-0">
              <div>
                <filterAgency class="my-0"/>
                <tableAgency class="mx-5 mb-5"/>
              </div>
            </div>
          </v-tab-item>
          <v-tab-item>
            <div class="my-0">
              <div>
                <titlePositionLevel/>
              </div>
            </div>
          </v-tab-item>
          <v-tab-item>
            <div class="my-0">
              <div>
                <titleGroupPositionLevel/>
              </div>
            </div>
          </v-tab-item>
        </v-tabs-items>
      </v-tabs>
    </div>
  </v-app>
</template>

<script>
import titleAgency from '@/components/_manageposition/_overview/title.vue'
import filterAgency from '@/components/_manageposition/_overview/filter.vue'
import tableAgency from '@/components/_manageposition/_overview/table.vue'
import titlePositionLevel from '@/components/_managepositionlevel/Overview.vue'
import titleGroupPositionLevel from '@/components/_managegrouppositionlevel/Overview.vue'
export default {
  data () {
    return {
      activeTab: 0,
      tab: 0,
      items: [
        'จัดการตำแหน่ง', 'จัดการระดับตำแหน่ง', 'จัดการกลุ่มระดับตำแหน่ง'
      ]
    }
  },
  components: {
    titleAgency,
    filterAgency,
    tableAgency,
    titlePositionLevel,
    titleGroupPositionLevel
  }
}
</script>

<style scoped></style>
